export default class ScrollObserver {
    constructor() {
        this.scrolled = false;
        window.addEventListener('scroll', this.scrollHandler.bind(this));
        window.addEventListener('load', () => this.scrollHandler());
    }

    scrollHandler() {
        const y = window.scrollY;
        
        if (y > 10) {
            if (!this.scrolled) {
                document.body.classList.add('scrolled');
                this.scrolled = true;
            }
        } else {
            if (this.scrolled) {
                document.body.classList.remove('scrolled');
                this.scrolled = false;
            }
        }
    }
}